import React ,{useEffect,useState} from 'react';
import "./AboutUs.scss";
import teamPhoto from "../../assets/TeamS&P.jpg";
import studioPhoto from "../../assets/studioPhoto.jpg";
import PhotoCarousel from "../more/PhotoCarousel";
import {fetchWithCache} from "../services/FirebaseData"
import { Helmet } from "react-helmet-async";

const baseData = {
  "recentWorks": [
    { "image": teamPhoto, "alt": "Fitting cloth" }
  ],
}

const AboutUs = () => {
  const [content, setContent] = useState(baseData);
  
  useEffect(() => {
        fetchWithCache("firebaseContent")
          .then((data) => setContent(data))
          .catch((error) => console.error("Error fetching content:", error));
      }, []);

  return (
    <div className="about-us">
    <Helmet>
    <title>Alterations By Sdenka And Paola | Cooper City, FL |About Us </title>
    <meta name="description" content="Learn about Alterations By Sdenka And Paola, a trusted clothing alterations business in Cooper City, Florida, offering expert tailoring services with a personal touch." />
    <link rel="canonical" href="https://www.alterationsbysdenka-paola.com/about-us" />
    </Helmet>
      <div className="about-usContent">
        <div className="containerAboutUs">
          <div className="text">
            <h1>Where Every Stitch Tells Your Story</h1>
            <p>
            Alterations By Sdenka And Paola is a premier, full-service provider of expert clothing alterations and custom tailoring. With over 25 years of experience, we deliver precision craftsmanship and exceptional service. Our mission is to offer flawless, personalized results, from hem adjustments to custom apparel and bridal gown tailoring, ensuring every fit is perfect.
            </p>
          </div>
          <img src={studioPhoto} alt="Our Studio" className="photoAboutUs" />
        </div>
        <div className="containerAboutUs2">
          <img src={teamPhoto} alt="Sdenka and Paola" className="photoAboutUs" />
          <div className="text">
            <h2>Our Talented Team</h2>
            <p>
            Sdenka and Paola bring decades of experience in tailoring and design to every project. Their dedication to excellence and attention to detail ensure every garment is handled with care and precision. From custom designs to complex bridal alterations, our team is here to make your vision a reality.
            </p>
          </div>
        </div>

          <h2 style={{marginBottom:0}}>Our Work, Your Style</h2>

          <PhotoCarousel worksImgs={content.recentWorks} />

        </div>
    </div>
  );
};

export default AboutUs;